import { createColumnHelper, flexRender } from "@tanstack/react-table";
import { buildColumns } from "./buildColumns";
import { DataTableDefinition, User } from "@/v2/types";
import { generateFilterColumn } from "../../filter";
import EditMember from "@/v2/page/members/Edit";
import ChangePassword from "../../pages/members/ChangePasswordForm";
import UserDeleteButton from "../../ui/button/delete/User";
import AccessControl from "../../rbac/AccessControl";

type T = User;
const columnHelper = createColumnHelper<T>();

const MembersColumnDefinition: DataTableDefinition<T>[] = [
    {
        id: "sl",
        headingText: "Sl No",
        headingCellType: "small-cell",
        cellType: "text-center",
    },
    {
        id: "full_name",
        headingText: "Name",
    },
    {
        id: "email",
        headingText: "Email",
    },
    {
        id: "phone_number",
        headingText: "Phone Number",
    },
    {
        id: "assigned_employee.full_name",
        headingText: "Assigned Employee",
    },

    {
        id: "roles",
        headingText: "Roles",
        cell: ({ row }) => {
            return (
                <div className="w-full text-left">
                    <span>{row?.roles?.[0]?.name}</span>
                </div>
            );
        },
    },
    {
        id: "actions",
        headingText: "Actions",
        headingCellType: "text-center",
        cell: ({ row }) =>
            flexRender(
                <div className="flex justify-center gap-2 text-black">
                    <AccessControl
                        module="USER_MANAGEMENT"
                        requestedAccess={["PUT"]}
                    >
                        <UserDeleteButton id={row.id} />

                        <EditMember id={row.id} />

                        <ChangePassword id={row.id} />
                    </AccessControl>
                </div>,
                {},
            ),
    },
];

const MembersColumn = buildColumns<T>(columnHelper, MembersColumnDefinition);

const MembersFilterColumn = generateFilterColumn<T>(
    MembersColumnDefinition,
    {},
);

export { MembersColumn, MembersFilterColumn };
